<template>
    <a class="btn btn-outline-secondary" :href="journeyUrl">
        <i class="fas fa-route"></i> {{resource('JourneyBuilder_Overview_Composer_Button_Text')}}
    </a>    
</template>

<script>
    import api from "@modules/JourneyBuilder/api";
    import resources from "@core/Util/Mixins/resources";
    
    export default {
        name: "NavigateToJourneyButton",
        mixins: [resources],
        computed: {
            journeyUrl() {
                return api.getViewJourneyUrl(this.journeyId || '');
            }
        },
        props: {
            journeyId: {
                type: String,
                required: false
            }
        }
    }
</script>
